import React, { Component } from "react"
import PropTypes from "prop-types"
import { startCase, get } from "lodash"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import {
  useEditingContext,
  useElement,
  useElements
} from "app/forms/data/form-data"
import { useStyles } from "app/forms/data/use-styles"
import { useBuilderState } from "app/forms/builder/builder-context"
import { Element } from "./element"
import { Types } from "./types"
import { CustomField } from "./custom-field"
import "./custom-fields.css"

import { Input } from "./input-element"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

export const createField = field => {
  if (field.name == "email_address") {
    return {
      label: startCase(field.name),
      ...field,
      group: "field",
      type: Types.Input,
      input_type: "email",
      required: true
    }
  } else {
    return {
      ...field,
      type: Types.Custom,
      input_type: field.type,
      custom_field_key: field.name,
      custom_field_label: startCase(field.name)
    }
  }
}

export const CustomFields = ({ children, direction, ...props }) => {
  // make sure the email input is created
  useElement("email_address", createField({ name: "email_address" }))
  const elements = useElements()
  const styles = useStyles()
  const editing = useEditingContext()
  const builderState = useBuilderState()

  const fields = elements.inputs.sort((a, b) => (a.order || 0) - (b.order || 0))

  const handleDragEnd = result => {
    const orderedFields = reorder(
      fields,
      get(result, "source.index"),
      get(result, "destination.index")
    )

    orderedFields.forEach((field, index) => {
      elements.update({ name: field.name, order: index })
    })
  }

  return (
    <React.Fragment>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable" direction={direction}>
          {provided => (
            <div
              data-element="fields"
              ref={provided.innerRef}
              {...props}
              className="seva-fields formkit-fields"
            >
              {fields.map((element, index) => {
                element.group = "field" // TODO: needed?

                const id = element.id || element.name
                return (
                  <Field
                    key={id}
                    id={id}
                    index={index}
                    provided={provided}
                    editing={editing}
                  >
                    {element.type == Types.Custom ? (
                      <Element
                        key={element.id || element.name}
                        element={element}
                        onChange={elements.update}
                        onClick={() => {
                          builderState.setActiveElement(element.name)
                        }}
                      >
                        <CustomField
                          style={styles.forElement("field")}
                          label={element.label}
                          name={element.custom_field_key}
                        />
                      </Element>
                    ) : (
                      <Input className="formkit-input" {...element} />
                    )}
                  </Field>
                )
              })}
              {provided.placeholder}
              {children}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </React.Fragment>
  )
}

CustomFields.propTypes = {
  children: PropTypes.any,
  direction: PropTypes.oneOf(["horizontal", "vertical"]),
  editing: PropTypes.bool,
  fields: PropTypes.array,
  elements: PropTypes.object,
  styles: PropTypes.object
}

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  ...draggableStyle
})

class Field extends Component {
  render() {
    const { children, editing, id, index } = this.props

    return (
      <Draggable draggableId={`${id}`} index={index} isDragDisabled={!editing}>
        {(provided, snapshot) => (
          <div
            className="formkit-field"
            ref={provided.innerRef}
            {...(editing ? provided.draggableProps : null)}
            {...provided.dragHandleProps}
            style={
              editing
                ? getItemStyle(
                    snapshot.isDragging,
                    provided.draggableProps.style
                  )
                : null
            }
          >
            {editing && (
              <div className="forms-draggable">
                <div className="forms-draggable-button">
                  <span />
                  <span />
                  <span />
                </div>
              </div>
            )}
            {children}
          </div>
        )}
      </Draggable>
    )
  }
}
